<footer
  class="site-footer"
  style="
    background-color: black;
    padding: 10px 0;
    color: #ccc;
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  "
>
  <div class="container">
    <p style="margin: 0" class="footer-container">
      Ploom Romania @ 2023 / JT International (România) SRL Dimitrie Pompei
      9-9A, sect. 2, București /
      <a href="tel:0212043111" style="color: white; text-decoration: none">
        021 204 3111
      </a>
      /
      <a
        href="/assets/Docs/Regulament-Chestionar-Ploom.pdf"
        target="_blank"
        style="color: white; text-decoration: underline"
      >
        Regulament Ploom Club
      </a>
    </p>
  </div>
</footer>
